/**
 * File: IconCard.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.0
 * Created: 2025-07-30
 * Last Updated: 2025-11-06
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function IconCard({ icon, text }) {
    return (
        <>
            <div className="icon-card">
                {icon}
                <p>{text}</p>
            </div>
        </>
    );
}

export default IconCard;
